const queryKeys = {
  chats: ['requestChats'],
  chat: (chatId: string) => ['requestChat', chatId]
}

export const useRequestChatsQuery = (options?: {
  refetchOnMount?: 'always' | boolean
  enabled?: MaybeRefOrGetter<boolean>
}) => {
  return useQueryWrapper({
    key: queryKeys.chats,
    query: () => requestChatService.getChats(),
    refetchOnMount: options?.refetchOnMount,
    enabled: options?.enabled ?? true
  }, [])
}

export const useRequestChatDetailQuery = (chatId: MaybeRefOrGetter<string>) => {
  return useQueryWrapper({
    key: () => queryKeys.chat(toValue(chatId)),
    query: () => requestChatService.getChat(toValue(chatId))
  }, null)
}

export const useChatsUnreadCount = () => {
  const { data: chats } = useRequestChatsQuery()

  const total = computed(() => (chats.value ?? []).reduce((sum, chat) => sum + chat.unreadCount, 0)
  )

  const byChatId = computed(() => {
    const map: Record<string, number> = {}
    for (const chat of chats.value ?? []) {
      map[chat.id] = chat.unreadCount
    }
    return map
  })

  return { total, byChatId }
}

export const requestChatQueryKeys = queryKeys
